import React, { forwardRef } from "react";
import styles from "./Radiobutton.css";
import Input from "./Input";
import { lastIndexOf } from "underscore";

const Radiobutton = forwardRef(({ children, ...props }, ref, value) => {
  value = props.value;
  console.log(value);

  if (value == "entfernen") {
    return (
      <label className={styles.RadiobuttonAsButtonLabel}>
        <Input
          className={styles.RadiobuttonAsButton}
          ref={ref}
          type="radio"
          {...props}
        />
        {children}
      </label>
    );
  } else {
    return (
      <label className={styles.Radiobutton}>
        <Input ref={ref} type="radio" {...props} />
        {children}
      </label>
    );
  }
});

export default Radiobutton;
